
import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import vuescroll from 'vuescroll'
export default {
name: 'books',
props: [],
components: {
XHeader,
CheckIcon,
Group,
Cell,
XButton,
XSwitch,
'scroller': vuescroll
},
data () {
return {
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
bookList: [
{
id: '0',
type: '公共课教材',
books: [
{
name: '高等数学Ⅰ',
price: 30
},
{
name: '大学英语Ⅰ',
price: 42
},
{
name: '中国近现代史纲要',
price: 26
}
],
seletedTotal: '0.00',
allCheck: false,
checkArray: []
},
{
id: '1',
type: '专业课教材',
books: [
{
name: '大学物理',
price: 38
},
{
name: '材料力学',
price: 42
},
{
name: '机械原理与设计',
price: 55
},
{
name: 'AutoCAD机械制图',
price: 55
}
],
seletedTotal: '0.00',
allCheck: false,
checkArray: []
}
],
isDelivery: false,
address: '兴庆校区5#宿舍楼503'
}
},
computed: {
title () {
return this.$route.params.title
}
},
created () {},
mounted () {
this.setCheckArray()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
submit () {},
selectAll (id) {
this.bookList.forEach(element => {
})

},
setCheckArray () {
this.bookList.forEach(element => {
element.books.forEach(sube => {
element.checkArray.push(false)
})

})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/books.vue